import { setLevel, debug, info, warn, error } from 'loglevel'
// const isDevServer = process.env.WEBPACK_DEV_SERVER;
// debug('process.env', process.env)
// debug('env', isDevServer, nodeEnv)

const nodeEnv = process.env.NODE_ENV;  // development or production
const lvl_ = nodeEnv == 'development' ? 'debug' : 'warn'
setLevel(lvl_)
console.log('env', nodeEnv)
debug('logLevel', lvl_)

export {
    nodeEnv,
    debug,
    info,
    warn,
    error,
}
